import React, {Fragment} from "react";
import ReamazeSetupModalForm from "./ReamazeSetupForm";
import {basicModalStyle} from "../../Utilities/basicModalStyles";
import BasicModal from "../../../../common/BasicModal";

export default function ReamazeSetupModal({ open, handleClose, handleOpen}) {
  return(
    <Fragment>
      <BasicModal
        open={open}
        handleClose={handleClose}
        handleOpen={handleOpen}
        title={'Connect with Reamaze'}
        style={basicModalStyle}
      >

        <ReamazeSetupModalForm
          description={'Please copy and paste your Reamaze credentials here:'}
          buttonLabel={'Submit'}
          openInNewTab={true}
          handleClose={handleClose} />
      </BasicModal>
    </Fragment>
  )
}